export const IconUser = () => (
    <svg width="23" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M18.9781 23C19.6968 23 20.3603 22.6143 20.716 21.9898L20.7807 21.8762C21.1628 21.2053 21.1196 20.3728 20.559 19.8419C19.3026 18.6519 16.6141 16.75 12.2656 16.75C7.89545 16.75 5.33609 18.6709 4.1707 19.8596C3.65463 20.386 3.63393 21.1776 3.99875 21.8181L4.09653 21.9898C4.45226 22.6143 5.11575 23 5.83445 23H18.9781Z"
            stroke="#898D8F"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M12.4062 11.8889C14.8915 11.8889 16.9062 9.89904 16.9062 7.44444C16.9062 4.98985 14.8915 3 12.4062 3C9.92097 3 7.90625 4.98985 7.90625 7.44444C7.90625 9.89904 9.92097 11.8889 12.4062 11.8889Z"
            stroke="#898D8F"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);
